import t from "./ghl-ui.es1561.js";
function e() {
  this.__data__ = t ? t(null) : {}, this.size = 0;
}
export {
  e as default
};
